import React from 'react';
import PropTypes from 'prop-types';

import Select from '../Select';
import Icon from '../Icon';

import './styles.css';

function Pagination({
  options, currentPage, pageLimit, totalItems, onPageLimitChange, onChangePage, ...props
}) {
  const _getMaxPages = () => (totalItems === 0 ? 1 : Math.ceil(totalItems / pageLimit));

  const renderNavControl = pageNumber => (
    <span
      key={pageNumber}
      className={
              `Pagination__nav-control${
              currentPage === pageNumber ? ' Pagination__nav-control--selected' : ''}`
          }
      onClick={() => onChangePage(pageNumber)}
    >
      {pageNumber}
    </span>
  );

  const renderMoreIcon = key => (
    <Icon
      key={key}
      className="Pagination__more-icon"
      name="more_horiz"
    />
  );

  const _renderPageControl = () => {
    const pageControl = [];

    if (maxPage < 6) {
      for (let i = 1; i <= maxPage; i++) {
        pageControl.push(renderNavControl(i));
      }
    } else {
      pageControl.push(renderNavControl(1));

      if (currentPage <= 3) {
        pageControl.push(renderNavControl(2));
        pageControl.push(renderNavControl(3));
        pageControl.push(renderNavControl(4));
        pageControl.push(renderMoreIcon('icon-more'));
      } else if (currentPage > 3 && currentPage <= maxPage - 3) {
        pageControl.push(renderMoreIcon('icon-more-1'));
        pageControl.push(renderNavControl(currentPage - 1));
        pageControl.push(renderNavControl(currentPage));
        pageControl.push(renderNavControl(currentPage + 1));
        pageControl.push(renderMoreIcon('icon-more-2'));
      } else {
        pageControl.push(renderMoreIcon('icon-more'));
        pageControl.push(renderNavControl(maxPage - 3));
        pageControl.push(renderNavControl(maxPage - 2));
        pageControl.push(renderNavControl(maxPage - 1));
      }

      pageControl.push(renderNavControl(maxPage));
    }

    return pageControl;
  };

  const _previousPage = () => {
    const previousPage = currentPage - 1;
    previousPage > 0 && onChangePage(previousPage);
  };

  const _nextPage = () => {
    const nextPage = currentPage + 1;
    nextPage <= maxPage && onChangePage(nextPage);
  };

  const maxPage = _getMaxPages();

  return (
    <div
      className="Pagination"
      {...props}
    >
      <div className="Pagination__page-limit">
        <span className="Pagination__page-limit-label">Resultados por página</span>
        <Select
          className="Pagination__dropdown"
          options={options}
          value={pageLimit}
          onChange={option => onPageLimitChange(option.value)}
          searchable={false}
          clearable={false}
        />
      </div>
      <div className="Pagination__nav">
        <span
          className={
                      `Pagination__nav-control${
                      currentPage === 1 ? ' Pagination__nav-control--disabled' : ''}`
                  }
          onClick={_previousPage}
        >
          <Icon
            className="Pagination__nav-control-icon"
            name="keyboard_arrow_left"
          />
        </span>
        {_renderPageControl()}
        <span
          className={
                      `Pagination__nav-control${
                      currentPage === maxPage ? ' Pagination__nav-control--disabled' : ''}`
                  }
          onClick={_nextPage}
        >
          <Icon
            className="Pagination__nav-control-icon"
            name="keyboard_arrow_right"
          />
        </span>
      </div>
    </div>
  );
}

Pagination.propTypes = {
  paginationConfig: PropTypes.object,
  currentPage: PropTypes.number,
  totalItems: PropTypes.number,
  onPageLimitChange: PropTypes.func,
  onChangePage: PropTypes.func,
};

export default Pagination;
